import React from 'react';

const GoingCampingSVG = () => (
  <svg
    className="slds-illustration__svg"
    viewBox="0 0 483 218"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-64.000000, -98.000000)">
        <g>
          <rect
            fillOpacity="0"
            fill="#D8D8D8"
            x="0"
            y="0"
            width="600"
            height="400"
          ></rect>
          <g
            transform="translate(115.000000, 154.000000)"
            className="slds-illustration__stroke-secondary"
            strokeLinecap="round"
            strokeWidth="3"
          >
            <path
              vectorEffect="non-scaling-stroke"
              d="M44,17.5 L63,17.5 C62.2789714,12.0723971 64.081543,7.53186978 68.4077148,3.87841797 C73.3754883,-0.195556641 79.2734375,0.717773438 82.440918,2.12353516 C85.6083984,3.52929687 87.9606934,5.46069336 89.5913086,9.10524041 C90.2822266,10.6397351 90.7517904,11.9379883 91,13"
            ></path>
            <path
              vectorEffect="non-scaling-stroke"
              d="M83,20.5 C84.0558268,16.8461914 86.2227376,14.4572754 89.5007324,13.333252 C94.4177246,11.6472168 99.0800781,13.8925781 100.942383,16.1518555 C102.804687,18.4111328 103.39502,20.2260742 103.746582,22.1201172 C103.980957,23.3828125 104.06543,24.8427734 104,26.5 C108.141764,26.3313802 110.918945,27.1647135 112.331543,29 C114.040039,31.1936035 114.215332,33.817627 113.593018,35.75 C112.970703,37.682373 110.894531,40.5 107,40.5 L28,40.5"
            ></path>
            <path
              vectorEffect="non-scaling-stroke"
              d="M18,27.5 L83.0004985,27.5"
            ></path>
            <path vectorEffect="non-scaling-stroke" d="M0,27.5 L8,27.5"></path>
          </g>
          <g
            transform="translate(381.000000, 185.000000)"
            className="slds-illustration__stroke-secondary"
            strokeLinecap="round"
            strokeWidth="3"
          >
            <path
              vectorEffect="non-scaling-stroke"
              d="M44,17.5 L63,17.5 C62.2789714,12.0723971 64.081543,7.53186978 68.4077148,3.87841797 C73.3754883,-0.195556641 79.2734375,0.717773438 82.440918,2.12353516 C85.6083984,3.52929687 87.9606934,5.46069336 89.5913086,9.10524041 C90.2822266,10.6397351 90.7517904,11.9379883 91,13"
            ></path>
            <path
              vectorEffect="non-scaling-stroke"
              d="M83,20.5 C84.0558268,16.8461914 86.2227376,14.4572754 89.5007324,13.333252 C94.4177246,11.6472168 99.0800781,13.8925781 100.942383,16.1518555 C102.804687,18.4111328 103.39502,20.2260742 103.746582,22.1201172 C103.980957,23.3828125 104.06543,24.8427734 104,26.5 C108.141764,26.3313802 110.918945,27.1647135 112.331543,29 C114.040039,31.1936035 114.215332,33.817627 113.593018,35.75 C112.970703,37.682373 110.894531,40.5 107,40.5 L28,40.5"
            ></path>
            <path
              vectorEffect="non-scaling-stroke"
              d="M18,27.5 L83.0004985,27.5"
            ></path>
            <path vectorEffect="non-scaling-stroke" d="M0,27.5 L8,27.5"></path>
          </g>
          <g transform="translate(245.500000, 236.500000) scale(-1, 1) translate(-245.500000, -236.500000) translate(124.500000, 187.000000)">
            <polyline
              vectorEffect="non-scaling-stroke"
              className="slds-illustration__stroke-secondary"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="0.5 97 97 0 168 69"
            ></polyline>
            <polyline
              vectorEffect="non-scaling-stroke"
              className="slds-illustration__stroke-secondary"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="145.5 46 168 25 241.5 99"
            ></polyline>
            <path
              vectorEffect="non-scaling-stroke"
              d="M149.072948,27.0372884 L155.148556,47 L150.514767,44.0361328 L143.5,38.2738261 L147.165427,27.0187879 C147.336449,26.4936498 147.900798,26.2065817 148.425936,26.3776034 C148.736361,26.4786994 148.977892,26.7249613 149.072948,27.0372884 Z"
              className="slds-illustration__fill-secondary"
              transform="translate(149.324278, 36.617027) scale(-1, 1) translate(-149.324278, -36.617027) "
            ></path>
          </g>
          <g transform="translate(66.000000, 270.500000)">
            <g transform="translate(10.339768, 0.275260)"></g>
            <path
              vectorEffect="non-scaling-stroke"
              d="M140.962142,26.4644491 C138.225735,20.0143094 131.944776,15.5029106 124.633892,15.5029106 C122.619663,15.5029106 120.683612,15.8453541 118.878328,16.4764392 C115.451481,11.1704266 109.567406,7.66985447 102.883789,7.66985447 C96.4912675,7.66985447 90.8301585,10.8721423 87.3508511,15.7935668 C85.9589956,14.968161 84.3423157,14.4956341 82.6177606,14.4956341 C81.1083143,14.4956341 79.6815102,14.8576334 78.4157672,15.5014039 C74.9975328,6.58722215 66.5098304,0.275259875 56.5804557,0.275259875 C47.4632836,0.275259875 39.5615782,5.59684366 35.6837305,13.3681823 C33.3912034,12.266973 30.8314865,11.6515593 28.1312741,11.6515593 C19.4373504,11.6515593 12.1998844,18.0312998 10.6476214,26.4644491 L140.962142,26.4644491 Z"
              className="slds-illustration__fill-secondary"
            ></path>
            <path
              vectorEffect="non-scaling-stroke"
              d="M0,25 L130,25"
              className="slds-illustration__stroke-secondary"
              strokeWidth="3"
              strokeLinecap="round"
            ></path>
          </g>
          <g transform="translate(351.000000, 255.000000)">
            <g transform="translate(0.293436, 0.054545)">
              <path
                vectorEffect="non-scaling-stroke"
                d="M165.428708,41.9454545 L0.0995432562,41.9454545 C0.0336614956,41.2089487 0,40.4630069 0,39.7090909 C0,26.2132599 10.7866531,15.2727273 24.0926641,15.2727273 C27.7492016,15.2727273 31.215485,16.0989227 34.3199502,17.5772977 C39.5712028,7.14424616 50.271428,0 62.6175975,0 C76.0636257,0 87.5573893,8.47383452 92.1862485,20.441159 C93.9002755,19.5768947 95.8324059,19.0909091 97.8764479,19.0909091 C100.211783,19.0909091 102.401037,19.7252784 104.285841,20.8333889 C108.997403,14.2263569 116.663488,9.92727273 125.320028,9.92727273 C138.043441,9.92727273 148.627152,19.2146805 150.834755,31.4671412 C151.487388,31.3631046 152.156394,31.3090909 152.837838,31.3090909 C159.117096,31.3090909 164.340238,35.8953699 165.428708,41.9454545 Z"
                className="slds-illustration__fill-secondary"
              ></path>
              <path
                vectorEffect="non-scaling-stroke"
                d="M32.7065637,40.4454545 L173.706564,40.4454545"
                className="slds-illustration__stroke-secondary"
                strokeWidth="3"
                strokeLinecap="round"
              ></path>
              <path
                vectorEffect="non-scaling-stroke"
                d="M179.706564,40.4454545 L193.706564,40.4454545"
                className="slds-illustration__stroke-secondary"
                strokeWidth="3"
                strokeLinecap="round"
              ></path>
            </g>
          </g>
          <g transform="translate(470.500000, 233.500000)">
            <g className="slds-illustration__fill-secondary">
              <path
                vectorEffect="non-scaling-stroke"
                d="M18.9209988,1.95433401 L33.259296,51.443436 C33.5666778,52.5043744 32.9557995,53.613617 31.8948612,53.9209988 C31.7139843,53.9734036 31.5266126,54 31.3382972,54 L2.6617028,54 C1.5571333,54 0.661702805,53.1045695 0.661702805,52 C0.661702805,51.8116846 0.688299176,51.6243129 0.74070397,51.443436 L15.0790012,1.95433401 C15.386383,0.893395645 16.4956256,0.282517358 17.556564,0.589899164 C18.2152102,0.780726338 18.7301717,1.29568777 18.9209988,1.95433401 Z"
              ></path>
            </g>
            <g
              className="slds-illustration__stroke-primary"
              strokeLinecap="round"
              strokeWidth="3"
            >
              <polygon
                vectorEffect="non-scaling-stroke"
                strokeLinejoin="round"
                points="17 0.323943662 34 54 -1.81721305e-12 54"
              ></polygon>
              <path
                vectorEffect="non-scaling-stroke"
                d="M17,4.6953125 C17,43.0456294 17,62.6471919 17,63.5 C17,62.6471919 17,43.0456294 17,4.6953125 Z"
              ></path>
              <path
                vectorEffect="non-scaling-stroke"
                d="M17,29.3239437 C22.3333333,35.7851611 25,39.1184944 25,39.3239437 C25,39.1184944 22.3333333,35.7851611 17,29.3239437 Z"
                strokeLinejoin="round"
                transform="translate(21.000000, 34.323944) scale(-1, 1) translate(-21.000000, -34.323944) "
              ></path>
            </g>
          </g>
          <g transform="translate(428.000000, 200.500000)">
            <g
              transform="translate(1.000000, 0.000000)"
              className="slds-illustration__fill-secondary"
            >
              <path
                vectorEffect="non-scaling-stroke"
                d="M25.6478873,0 L50.879042,84.4273253 C51.1953215,85.4856452 50.5937789,86.5999782 49.535459,86.9162577 C49.3496374,86.9717906 49.1567264,87 48.9627843,87 L2.33299037,87 C1.22842087,87 0.332990367,86.1045695 0.332990367,85 C0.332990367,84.8060578 0.361199757,84.6131469 0.416732643,84.4273253 L25.6478873,0 Z"
              ></path>
            </g>
            <g
              className="slds-illustration__stroke-primary"
              strokeLinecap="round"
              strokeWidth="3"
            >
              <polygon
                vectorEffect="non-scaling-stroke"
                strokeLinejoin="round"
                points="26.5 0 52.5 87 0.5 87"
              ></polygon>
              <path
                vectorEffect="non-scaling-stroke"
                d="M26.5,3.58642578 C26.5,64.0261034 26.5,94.9972948 26.5,96.5 C26.5,94.9972948 26.5,64.0261034 26.5,3.58642578 Z"
              ></path>
              <path
                vectorEffect="non-scaling-stroke"
                d="M15.6478873,42 C22.9812207,49.078692 26.6478873,52.7453587 26.6478873,53 C26.6478873,52.7453587 22.9812207,49.078692 15.6478873,42 Z"
                strokeLinejoin="round"
              ></path>
              <path
                vectorEffect="non-scaling-stroke"
                d="M27.6478873,68 C36.9812207,57.078692 41.6478873,51.7453587 41.6478873,52 C41.6478873,51.7453587 36.9812207,57.078692 27.6478873,68 Z"
                strokeLinejoin="round"
              ></path>
            </g>
          </g>
          <g transform="translate(123.500000, 234.500000)">
            <g className="slds-illustration__fill-secondary">
              <path
                vectorEffect="non-scaling-stroke"
                d="M18.9209988,1.95433401 L33.259296,51.443436 C33.5666778,52.5043744 32.9557995,53.613617 31.8948612,53.9209988 C31.7139843,53.9734036 31.5266126,54 31.3382972,54 L2.6617028,54 C1.5571333,54 0.661702805,53.1045695 0.661702805,52 C0.661702805,51.8116846 0.688299176,51.6243129 0.74070397,51.443436 L15.0790012,1.95433401 C15.386383,0.893395645 16.4956256,0.282517358 17.556564,0.589899164 C18.2152102,0.780726338 18.7301717,1.29568777 18.9209988,1.95433401 Z"
              ></path>
            </g>
            <g className="slds-illustration__stroke-primary" strokeWidth="3">
              <polygon
                vectorEffect="non-scaling-stroke"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="17 0.323943662 34 54 -1.81721305e-12 54"
              ></polygon>
              <path
                vectorEffect="non-scaling-stroke"
                d="M17,4.32394366 C17,42.2551731 17,61.6471919 17,62.5 C17,61.6471919 17,42.2551731 17,4.32394366 Z"
              ></path>
              <path
                vectorEffect="non-scaling-stroke"
                d="M17,32.3239437 C23.6666667,39.4518278 27,43.1184944 27,43.3239437 C27,43.1184944 23.6666667,39.4518278 17,32.3239437 Z"
                strokeLinecap="round"
                strokeLinejoin="round"
                transform="translate(22.000000, 37.823944) scale(-1, 1) translate(-22.000000, -37.823944) "
              ></path>
            </g>
          </g>
          <g transform="translate(286.000000, 81.000000)">
            <g>
              <circle
                vectorEffect="non-scaling-stroke"
                className="slds-illustration__fill-secondary"
                cx="64"
                cy="64"
                r="23"
              ></circle>
              <circle
                vectorEffect="non-scaling-stroke"
                className="slds-illustration__stroke-secondary"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="135,1,1,18"
                transform="translate(64.000000, 64.000000) rotate(230.000000) translate(-64.000000, -64.000000) "
                cx="64"
                cy="64"
                r="45"
              ></circle>
              <circle
                vectorEffect="non-scaling-stroke"
                className="slds-illustration__stroke-secondary"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="107,10"
                transform="translate(64.000000, 64.000000) rotate(150.000000) translate(-64.000000, -64.000000) "
                cx="64"
                cy="64"
                r="33"
              ></circle>
            </g>
            <g
              transform="translate(41.000000, 41.000000)"
              className="slds-illustration__stroke-primary"
              strokeWidth="3"
            >
              <circle
                vectorEffect="non-scaling-stroke"
                cx="23"
                cy="23"
                r="23"
              ></circle>
            </g>
          </g>
          <g transform="translate(231.000000, 232.500000)">
            <g transform="translate(0.000000, 11.000000)" fill="#FFFFFF">
              <circle
                vectorEffect="non-scaling-stroke"
                cx="12"
                cy="12"
                r="12"
              ></circle>
              <circle
                vectorEffect="non-scaling-stroke"
                cx="40"
                cy="12"
                r="12"
              ></circle>
            </g>
            <g
              transform="translate(1.000000, 0.000000)"
              className="slds-illustration__stroke-primary"
              strokeWidth="3"
            >
              <path
                vectorEffect="non-scaling-stroke"
                d="M43,1 L35,19"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <circle
                vectorEffect="non-scaling-stroke"
                cx="11"
                cy="23"
                r="11"
              ></circle>
              <circle
                vectorEffect="non-scaling-stroke"
                cx="39"
                cy="23"
                r="11"
              ></circle>
              <polyline
                vectorEffect="non-scaling-stroke"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="11.5823267 0 20 0 11 23"
              ></polyline>
              <polyline
                vectorEffect="non-scaling-stroke"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="39 6 19 6 39 23"
              ></polyline>
            </g>
          </g>
          <g transform="translate(192.000000, 265.500000)">
            <g
              transform="translate(25.000000, 0.000000)"
              className="slds-illustration__fill-secondary"
            >
              <path
                vectorEffect="non-scaling-stroke"
                d="M0.924804688,16.3183594 L12.0722656,1.08691406 L63.9746094,0.530273437 C65.7576937,0.394926274 66.8719516,0.672758305 67.3173828,1.36376953 C67.7628141,2.05478076 68.0753141,4.72698128 68.2548828,9.38037109 L68.2548828,17.0683594 L0.924804688,16.3183594 Z"
              ></path>
            </g>
            <g transform="translate(4.000000, 16.000000)" fill="#FFFFFF">
              <path
                vectorEffect="non-scaling-stroke"
                d="M5.68920898,0.754150391 C3.81560617,2.20807808 2.60523833,3.3938691 2.05810547,4.31152344 C1.5109726,5.22917777 1.09975841,6.76311332 0.824462891,8.91333008 L1.19946289,19.7626953 C59.9597168,20.4951172 89.3398438,20.6782227 89.3398438,20.3120117 C89.3398438,19.9458008 89.078125,13.3500977 88.5546875,0.524902344 L5.68920898,0.754150391 Z"
              ></path>
              <circle
                vectorEffect="non-scaling-stroke"
                cx="73"
                cy="21.5"
                r="11"
              ></circle>
              <circle
                vectorEffect="non-scaling-stroke"
                cx="19"
                cy="21.5"
                r="11"
              ></circle>
            </g>
            <g
              transform="translate(0.000000, 1.000000)"
              className="slds-illustration__stroke-primary"
              strokeLinecap="round"
              strokeWidth="3"
            >
              <path
                vectorEffect="non-scaling-stroke"
                d="M4.5,35 L4.5,23.5 C4.5,19.9333496 6.65779044,16 13.9491525,16 L25.8813559,16 L33.3504859,4.18951649 C35.000004,1.58123315 37.8709063,5.89597905e-15 40.9570126,5.32907052e-15 L87.5,0 C90.8137085,-6.08718376e-16 93.5,2.6862915 93.5,6 L93.5,35 L87.8985813,35 C87.9654546,35.4904531 88,35.9911923 88,36.5 C88,42.5751322 83.0751322,47.5 77,47.5 C70.9248678,47.5 66,42.5751322 66,36.5 C66,35.9911923 66.0345454,35.4904531 66.1014187,35 L33.8985813,35 C33.9654546,35.4904531 34,35.9911923 34,36.5 C34,42.5751322 29.0751322,47.5 23,47.5 C16.9248678,47.5 12,42.5751322 12,36.5 C12,35.9911923 12.0345454,35.4904531 12.1014187,35 L4.5,35 Z"
                strokeLinejoin="round"
              ></path>
              <circle
                vectorEffect="non-scaling-stroke"
                strokeLinejoin="round"
                cx="77"
                cy="36.5"
                r="11"
              ></circle>
              <circle
                vectorEffect="non-scaling-stroke"
                strokeLinejoin="round"
                cx="23"
                cy="36.5"
                r="11"
              ></circle>
              <path vectorEffect="non-scaling-stroke" d="M0,35 L12,35"></path>
              <path
                vectorEffect="non-scaling-stroke"
                d="M99.5,10.5 L99.5,25.5"
              ></path>
              <path
                vectorEffect="non-scaling-stroke"
                d="M58.5,1.5 L58.5,14.5"
              ></path>
              <polyline
                vectorEffect="non-scaling-stroke"
                points="26 16 34.7470703 16 92.5 16"
              ></polyline>
            </g>
          </g>
          <g transform="translate(282.000000, 234.500000)">
            <g
              transform="translate(25.000000, 0.000000)"
              className="slds-illustration__fill-secondary"
            >
              <path
                vectorEffect="non-scaling-stroke"
                d="M2.01464844,13.4511719 L0.18359375,22.2475586 L0.18359375,49.0366211 L65.9321289,49.0366211 L62.9897461,54.4458008 L95.7871094,54.4458008 L95.199707,29.3144531 L89.3999023,17.3056641 L75.6298828,10.543457 C59.2139757,10.1238607 43.9452582,9.9140625 29.8237305,9.9140625 C15.7022027,9.9140625 6.43250868,11.093099 2.01464844,13.4511719 Z"
              ></path>
              <rect x="27.5" y="0" width="27" height="10" rx="2"></rect>
            </g>
            <g transform="translate(24.000000, 9.000000)" fill="#FFFFFF">
              <polygon
                vectorEffect="non-scaling-stroke"
                points="0.634277344 40.8232422 67.1601562 40.8232422 64.1865234 45.4521484 96.6953125 46.4760742 93.1474609 54.6992188 84.7587891 57.7099609 11.0742187 58.3500977 0.634277344 57.7099609"
              ></polygon>
              <circle
                vectorEffect="non-scaling-stroke"
                cx="66"
                cy="59.5"
                r="11"
              ></circle>
              <path
                vectorEffect="non-scaling-stroke"
                d="M1.52783203,11.3217773 C4.92236328,6.82128906 8.36539714,4.55810547 11.8569336,4.53222656 C15.3484701,4.50634766 35.8100628,4.50634766 73.241712,4.53222656 C83.0900108,5.16178385 90.4536947,10.2570801 95.3327637,19.8181152 C100.211833,29.3791504 99.1593424,26.0000814 92.175293,9.6809082 C88.4861654,6.10766602 86.5785319,4.27368164 86.4523926,4.17895508 C86.3262533,4.08422852 82.7312012,2.83650716 75.6672363,0.435791016 L58.2929688,0.435791016 L11.5412598,0.435791016 L4.86254883,2.60107422 L1.52783203,6.31982422 L1.52783203,11.3217773 Z"
              ></path>
            </g>
            <g className="slds-illustration__stroke-primary" strokeWidth="3">
              <path
                vectorEffect="non-scaling-stroke"
                d="M108.5,67 C115.127417,67 120.5,61.627417 120.5,55 L120.5,34 C120.5,20.745166 109.754834,10 96.5,10 L36.5,10 C29.872583,10 24.5,15.372583 24.5,22 L24.5,67 L79.1014187,67 C79.0345454,67.4904531 79,67.9911923 79,68.5 C79,74.5751322 83.9248678,79.5 90,79.5 C96.0751322,79.5 101,74.5751322 101,68.5 C101,67.9911923 100.965455,67.4904531 100.898581,67 L108.5,67 Z"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                vectorEffect="non-scaling-stroke"
                d="M54.5,0 L77.5,0 C78.6045695,-2.02906125e-16 79.5,0.8954305 79.5,2 L79.5,10 L52.5,10 L52.5,2 C52.5,0.8954305 53.3954305,2.02906125e-16 54.5,0 Z"
              ></path>
              <rect x="38.5" y="24" width="24" height="43" rx="1"></rect>
              <rect x="75.5" y="24" width="30" height="15" rx="1"></rect>
              <polyline
                vectorEffect="non-scaling-stroke"
                points="25 49 91.5 49 86.9943799 55 120.5 55"
              ></polyline>
              <path
                vectorEffect="non-scaling-stroke"
                d="M105.004883,67 L0,67"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default GoingCampingSVG;
